import { defineMessages } from 'react-intl';

export default defineMessages({
    FarmersCopyright: {
        id: 'ml.quoteandbind.common.footer.farmers copyright',
        defaultMessage: '© {year} Farmers Insurance'
    },
    FarmersCopyrightQB: {
        id: 'ml.quoteandbind.common.footer.farmers copyright Qb',
        defaultMessage: '© {year} Farmers'
    },
    FarmersCopyrightAMP: {
        id: 'ml.quoteandbind.common.footer.farmers copyright amp',
        defaultMessage: '© {year} Farmers Insurance'
    },
    ForemostCopyright: {
        id: 'ml.quoteandbind.common.footer.foremost copyright',
        defaultMessage: '© {year} Foremost Insurance'
    },
    FarmersDisclosure: {
        id: 'ml.quoteandbind.common.footer.farmers disclosure',
        defaultMessage: 'Advertisement produced on behalf of the following specific insurers and seeking to obtain business for insurance underwritten by Farmers Property and Casualty Insurance Company (a MA & MN licensee) and certain of its affiliates: Economy Fire & Casualty Company, Economy Premier Assurance Company, Economy Preferred Insurance Company, Farmers Casualty Insurance Company (a MN licensee), Farmers Direct Property and Casualty Insurance Company (CA Certificate of Authority: 6730; Warwick, RI), Farmers Group Property and Casualty Insurance Company (CA COA: 6393; Warwick, RI), or Farmers Lloyds Insurance Company of Texas, all with administrative home offices at 700 Quaker Lane, Warwick, RI 02886. Coverage, rates, discounts, and policy features vary by state and product and are available in most states to those who qualify. Policies have exclusions, limitations, and terms under which the policy may be continued in force or discontinued. For costs and complete details of coverage, contact your local representative or the company.'
    },
    PrivacyPolicy: {
        id: 'ml.quoteandbind.common.footer.Privacy Policy',
        defaultMessage: 'Privacy Policy'
    },
    LegalNotices: {
        id: 'ml.quoteandbind.common.footer.Legal Notices',
        defaultMessage: 'Legal Notices'
    },
    OnlineTermsOfService: {
        id: 'ml.quoteandbind.common.footer.Online Terms of Service',
        defaultMessage: 'Online Terms of Service'
    },
    ourComponies: {
        id: 'ml.quoteandbind.common.footer.Our companies ',
        defaultMessage: 'Our companies'
    },
    FindAnAgent: {
        id: 'ml.quoteandbind.common.footer.FIND AN AGENT',
        defaultMessage: 'FIND AN AGENT'
    },
    SearchAgentInYourArea: {
        id: 'ml.quoteandbind.common.footer.Search for an agent in your area',
        defaultMessage: 'Search for an agent in your area'
    },
    SearchForAnAgent: {
        id: 'ml.quoteandbind.common.footer.Search for an Agent',
        defaultMessage: 'Search for an Agent'
    },
    ChatRepresentative: {
        id: 'ml.quoteandbind.common.footer.CHAT WITH A REPRESENTATIVE',
        defaultMessage: 'CHAT WITH A REPRESENTATIVE'
    },
    AskQuestionGetAnswers: {
        id: 'ml.quoteandbind.common.footer.Ask questions and get answers',
        defaultMessage: 'Ask questions and get answers'
    },
    ChatNow: {
        id: 'ml.quoteandbind.common.footer.Chat Now',
        defaultMessage: 'Chat Now'
    },
    CallRepresentative: {
        "id": "ml.quoteandbind.common.footer.Call a representative",
        "defaultMessage": "Call a representative"
    },
    HereToGuideYou: {
        id: 'ml.quoteandbind.common.footer.We\'re here to guide you and assist you',
        defaultMessage: 'We\'re here to guide you and assist you'
    },
    GetAnswers: {
        id: 'ml.quoteandbind.common.footer.Get answers',
        defaultMessage: 'Get answers'
    },
    GetAnswersCommonQuestions: {
        id: 'ml.quoteandbind.common.footer.Get answers to common questions',
        defaultMessage: 'Get answers to common questions'
    },
    FAQ: {
        id: 'ml.quoteandbind.common.footer.FAQ',
        defaultMessage: 'FAQ'
    },
    FollowUs: {
        id: 'ml.quoteandbind.common.footer.FOLLOW US',
        defaultMessage: 'FOLLOW US'
    },
    JoinConversation: {
        id: 'ml.quoteandbind.common.footer.Join the conversation and get involved',
        defaultMessage: 'Join the conversation and get involved'
    },
    MondaoToFriday: {
        id: 'ml.quoteandbind.common.footer.Monday - Friday',
        defaultMessage: 'Monday - Friday:'
    },
    Saturday: {
        id: 'ml.quoteandbind.common.footer.Saturday',
        defaultMessage: 'Saturday:'
    },
    Sunday: {
        id: 'ml.quoteandbind.common.footer.Sunday',
        defaultMessage: 'Sunday:'
    },
    _8am1030pm: {
        id: 'ml.quoteandbind.common.footer.8:00am - 10:30pm ET',
        defaultMessage: '8:00 am - 10:30 pm ET'
    },
    _8am8pm: {
        id: 'ml.quoteandbind.common.footer.8:00am - 8:00pm ET',
        defaultMessage: '8:00 am - 8:00 pm ET'
    },
    _9am530pm: {
        id: 'ml.quoteandbind.common.footer.9:00am - 5:30pm ET',
        defaultMessage: '9:00 am - 5:30 pm ET'
    },
    _12pm630pm: {
        id: 'ml.quoteandbind.common.footer.12:00pm - 6:30pm ET',
        defaultMessage: '12:00 pm - 6:30 pm ET'
    },
    personalInfoUseLink: {
        id: 'ml.quoteandbind.common.footer.Personal Information Use',
        defaultMessage: 'Personal Information Use'
    },
    doNotSellLink: {
        id: 'ml.quoteandbind.common.footer.Do Not Sell/Share My Information',
        defaultMessage: 'Do Not Sell/Share My Information'
    }

});
